import React from "react";
import { useNavigate } from "react-router-dom";
import "./Breadcrumb.css";

const Breadcrumb = ({ items = [] }) => {
  const navigate = useNavigate();

  const handleItemClick = (item) => {
    if (item.onClick) {
      item.onClick();
    } else if (item.path) {
      navigate(item.path);
    }
  };

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className="breadcrumbContainer">
      <div className="breadcrumb">
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <span
              className={`breadcrumb__item ${
                item.isActive ? "breadcrumb__item--active" : ""
              }`}
              onClick={
                !item.isActive && (item.onClick || item.path)
                  ? () => handleItemClick(item)
                  : undefined
              }
              style={item.isActive ? { cursor: 'default' } : {}}
            >
              {item.label}
            </span>
            {index < items.length - 1 && (
              <span className="breadcrumb__separator">/</span>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Breadcrumb; 